import { computed, onUnmounted, ref } from 'vue';

export const useTimer = (frequency: number = 1000) => {
  const currentTime = ref(Date.now());

  const intervalId = setInterval(() => {
    currentTime.value = Date.now();
  }, frequency);

  const currentTimeInSeconds = computed(() => Math.floor(currentTime.value / 1_000));

  onUnmounted(() => {
    clearInterval(intervalId);
  });

  return {
    currentTime,
    currentTimeInSeconds,
  };
};
